import LegalDocumentPage from "./LegalDocumentPage"

export default function PrivacyPolicyPage() {
    return (
        <LegalDocumentPage
            title="Privacy Policy"
            subtitle="How HomeIndex handles personal data, third-party services, and consent-gated analytics."
            canonicalPath="/privacy"
            sections={[
                {
                    title: "What we collect",
                    paragraphs: [
                        "HomeIndex collects the information needed to provide property valuations, account access, payments, saved valuations, and support.",
                        "Depending on how you use the site, this can include the address or area you search, account details, login state, payment state, and messages you send to us.",
                    ],
                    bullets: [
                        "Google OAuth sign-in data when you choose Google login.",
                        "Stripe payment and checkout data when you buy a plan.",
                        "Property search and valuation requests you submit to the site.",
                        "Feature-research answers you choose to submit, including your email and any optional comments.",
                    ],
                },
                {
                    title: "Third-party services",
                    paragraphs: [
                        "We use a small number of third-party services to run the product. Some are necessary to deliver core features, while others only load if you consent to analytics or marketing.",
                    ],
                    bullets: [
                        "Google OAuth for sign-in.",
                        "Stripe for payments.",
                        "OpenStreetMap tiles for maps.",
                        "Google Maps / Street View APIs for imagery and property-related lookups.",
                        "PostHog if analytics consent is granted.",
                        "Google Analytics and Google Ads if the relevant consent is granted.",
                    ],
                },
                {
                    title: "Why we process data",
                    paragraphs: [
                        "We process data to provide valuations, secure accounts, process payments, remember essential site state, and improve the product when you opt into analytics.",
                        "We do not use the consent banner to block login, payment, or core valuation functionality.",
                    ],
                },
                {
                    title: "Your choices",
                    paragraphs: [
                        "You can change cookie choices from the footer at any time. If you reject non-essential cookies, we stop loading the optional analytics and marketing tools and clear the related storage where practical.",
                    ],
                },
            ]}
        />
    )
}
